import React, { useRef } from 'react';
import Button from '@mui/material/Button';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

function FileUploadButton({ onFilesSelected, onFileCountChanged }) {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      onFilesSelected(files);
      onFileCountChanged(files.length); // Notify parent about the file count
    }
  };

  return (
    <div>
      <Button
        size="small"
        variant="outlined"
        color="secondary"
        sx={{ borderStyle: 'dashed', textTransform: 'none' }}
        startIcon={<FileUploadOutlinedIcon sx={{ fontSize: 16 }} />}
        onClick={handleButtonClick}
      >
        Upload File
      </Button>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        multiple
      />
    </div>
  );
}

export default FileUploadButton;
